import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { permissionGuard } from './core/guards/permission.guard';
import { MainLayoutComponent } from './shared/components/main-layout/main-layout.component';
import { FederationShellComponent } from './shared/components/federation-shell/federation-shell.component';
import { UnauthorizedComponent } from './pages/unauthorized/unauthorized.component';

export const routes: Routes = [
  {
    path: '',
    component: FederationShellComponent,
    children: [
      // Landing page — role selector (Espace Fédération / Espace Clubs)
      {
        path: 'accueil',
        loadChildren: () =>
          import('./pages/landing/landing.module').then((m) => m.LandingModule),
      },

      // Public auth routes
      {
        path: 'federation/auth',
        loadChildren: () =>
          import('./pages/auth/auth.module').then((m) => m.AuthModule),
      },
      {
        path: 'club/auth',
        loadChildren: () =>
          import('./pages/auth/auth.module').then((m) => m.AuthModule),
      },

      // Protected routes — wrapped in MainLayoutComponent + AuthGuard
      {
        path: '',
        component: MainLayoutComponent,
        canActivate: [AuthGuard],
        runGuardsAndResolvers: 'always',
        children: [
          {
            path: 'Joueurs',
            canActivate: [permissionGuard('licence', 'joueurs', 'read')],
            loadChildren: () =>
              import('./pages/players/players.module').then((m) => m.PlayersModule),
          },
          {
            path: 'club',
            canActivate: [permissionGuard('licence', 'clubs', 'read')],
            loadChildren: () =>
              import('./pages/club/club.module').then((m) => m.ClubModule),
          },
          {
            path: 'Clubs',
            redirectTo: '/federation/clubs',
            pathMatch: 'full',
          },
          {
            path: 'federation',
            loadChildren: () =>
              import('./pages/federation/federation.module').then((m) => m.FederationModule),
          },
          {
            path: 'Dirigeants',
            canActivate: [permissionGuard('licence', 'dirigeants', 'read')],
            loadChildren: () =>
              import('./pages/managers/managers.module').then((m) => m.ManagersModule),
          },
          {
            path: 'Staff',
            canActivate: [permissionGuard('licence', 'staff', 'read')],
            loadChildren: () =>
              import('./pages/technical-staff/technical-staff.module').then((m) => m.TechnicalStaffModule),
          },
          {
            path: 'Arbitres',
            canActivate: [permissionGuard('licence', 'arbitres', 'read')],
            loadChildren: () =>
              import('./pages/referee/referee.module').then((m) => m.RefereeModule),
          },
          {
            path: 'Formulaires',
            canActivate: [permissionGuard('licence', 'formulaires', 'read')],
            loadChildren: () =>
              import('./pages/formulaires/formulaires.module').then((m) => m.FormulairesModule),
          },
          {
            path: 'Demandes',
            canActivate: [permissionGuard('licence', 'demandes', 'read')],
            loadChildren: () =>
              import('./pages/demandes/demandes.module').then((m) => m.DemandesModule),
          },
          {
            path: 'Saisons',
            canActivate: [permissionGuard('licence', 'seasons', 'read')],
            loadChildren: () =>
              import('./pages/seasons/seasons.module').then((m) => m.SeasonsModule),
          },
          { path: '', redirectTo: 'club', pathMatch: 'full' },
        ],
      },

      // Error pages — outside AuthGuard, no layout
      { path: 'unauthorized', component: UnauthorizedComponent },
      { path: 'no-access', component: UnauthorizedComponent },

      { path: '**', redirectTo: '' }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}

// Preserve query params on redirects
export const routerConfig = {
  errorHandler: (error: any) => console.error('Router error:', error),
};

